import * as actionTypes from "../../Actions/Analytics/ActionTypes";
import * as actionReducer from "./ActionReducer";

const initialState = {
  analytics: null,
  interval: "HOUR",
  missionStatus: [],
  distanceOfDelivery: [],
  durationOfDelivery: [],
  accuracyOfDelivery: [],
  totalMissionStatus: [
    { name: 'Rejected', value: 0, color: '#ff4d4d' },
    { name: 'Completed', value: 0, color: '#33ff99' },
    { name: 'Remaining', value: 0, color: '#00cccc' },
    { name: 'No Receiver', value: 0, color: '#ff8080' },
    { name: 'Half Delivered', value: 0, color: '#ffff99' },
  ],

  getAllData: {
    request: null,
    response: null,
    error: null,
  },

  noChartData: {
    AvgDuration: false,
    AvgDistance: false,
    missionStatusPie: false,
    missionStatusStack: false,
  },

  Excel: {
    AvgDuration: "",
    AvgDistance: "",
    Delivery: "",
  }
};

const AnalyticsReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.CLEAR_STATE:
      return actionReducer.ClearState(state, action, initialState);

    case actionTypes.SET_INTERVAL:
      return actionReducer.setInterval(state, action);

    case actionTypes.GET_DATA:
      return actionReducer.getAllData(state, action);
    case actionTypes.GET_DATA_SUCCESS:
      return actionReducer.getAllDataSuccess(state, action);
    case actionTypes.GET_DATA_FAIL:
      return actionReducer.getAllDataFail(state, action);

    default:
      return state;
  }
};

export { AnalyticsReducer };